import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';

import {StaticFocusable} from '../../sections/StaticFocusable';

import {styles} from './FieldWrapper.style';
import type {FieldWrapperProps} from './FieldWrapper.types';

export const FieldWrapper = ({
  label,
  labelID,
  labelTestID,
  errorText,
  errorTestID,
  children,
  required,
}: FieldWrapperProps) => {
  const labelText = required ? `${label}, required` : label;
  const errorLabel = `${label} error. ${errorText}`;

  return (
    <View style={styles.fieldWrapper}>
      <StaticFocusable label={labelText}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          variant="caption"
          style={styles.fieldLabel}
          testID={labelTestID}
          nativeID={labelID}
          accessible
          accessibilityRole="text"
          accessibilityLabel={labelText}
          isBold>
          {label}
          {required && <Text style={styles.required}> *</Text>}
        </Text>
      </StaticFocusable>

      {children}

      {!!errorText && (
        <StaticFocusable testID={errorTestID} label={errorLabel} role="alert">
          <Text
            allowFontScaling
            maxFontSizeMultiplier={2}
            accessible
            accessibilityRole="alert"
            accessibilityLabel={errorLabel}
            style={styles.errorText}
            testID={errorTestID}>
            {errorText}
          </Text>
        </StaticFocusable>
      )}
    </View>
  );
};

export default FieldWrapper;
